// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload .upload-draggable {\n  width: 100%;\n}\n.small-padding {\n  padding: 5px 10px;\n}\n.aspectos-border {\n  max-height: 80px;\n  overflow-y: scroll;\n  border: 1px solid #CACACA;\n  padding: 9px;\n}", ""]);
// Exports
module.exports = exports;
